import styled from "styled-components";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";

export const TimeSelectWrapper = styled.div`
  ${FLEX.FlexCenterCenter};
  gap: 6px;
  > span {
    white-space: nowrap;
    font-size: ${calcRem(14)};
    font-weight: bold;
    color: ${({ theme }) => theme.COLORS.WHITE};
  }
  .time-select {
    min-width: 200px;
  }
`;
export const FirmwareUpgradeStyled = styled.div`
  .header-container {
    display: block;
    > .title-left {
      width: 100%;
      display: block;
      div {
        width: 100%;
      }
    }
    .right-aside {
      display: none;
    }
  }
`;
export const InfoWrapper = styled.div`
  ${FLEX.FlexStartStart};
  width: 100%;
  gap: 6px;
  color: ${({ theme }) => theme.COLORS.SELECTED};
  background-color: ${({ theme }) => theme.COLORS.SELECTED}10;
  border: 1px solid ${({ theme }) => theme.COLORS.SELECTED}50;
  padding: 10px;
  border-radius: 4px;
  width: 100%;
`;
export const TitleDescription = styled.div`
  width: 100%;
  p {
    ${FLEX.FlexStartCenter};
    width: 100%;
    gap: 6px;
    padding-bottom: 10px;
    color: ${({ theme }) => theme.COLORS.WHITE}60;
  }
`;
export const ItemTitle = styled.div`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  font-size: ${calcRem(16)};
  gap: 6px;
  padding-bottom: 10px;
  white-space: normal;
  small {
    font-size: ${calcRem(14)};
    color: ${({ theme }) => theme.COLORS.GRAY};
    font-weight: 400;
  }
`;

export const ButtonWrapper = styled.div`
  ${FLEX.FlexCenterCenter};
  gap: 10px;
  width: 100%;
  margin-top: 20px;
`;

export const CheckboxItem = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 6px;
  padding: 3px 0;
  label {
    font-size: ${calcRem(14)};
    color: ${({ theme }) => theme.COLORS.WHITE};
    font-weight: 400;
  }
  input[type="checkbox"] {
    width: 15px;
    height: 15px;
    margin-top: 0;
  }
`;
